export default ({ app, router, store, Vue }) => {
  const showElement = (el, show) => {
    if (!show) {
      el.style.display = 'none'
    }
  }

  const directive = (el, binding, ofActiveTeam, ofTeam) => {
    const team = binding.value
    const user = store.getters.user

    if (!user) {
      return showElement(el, false)
    }

    if (team) {
      return showElement(el, user[ofTeam](team))
    }

    return showElement(el, user[ofActiveTeam]())
  }

  Vue.directive('is-member', {
    inserted: function (el, binding) {
      return directive(el, binding, 'isMemberOfActiveTeam', 'isMemberOf')
    }
  })

  Vue.directive('is-user', {
    inserted: function (el, binding) {
      return directive(el, binding, 'isUserOfActiveTeam', 'isUserOf')
    }
  })

  Vue.directive('is-admin', {
    inserted: function (el, binding) {
      return directive(el, binding, 'isAdminOfActiveTeam', 'isAdminOf')
    }
  })

  Vue.directive('is-owner', {
    inserted: function (el, binding) {
      return directive(el, binding, 'isOwnerOfActiveTeam', 'isOwnerOf')
    }
  })
}
